export default "__VITE_ASSET__Dmsf7RwC__"